import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import clsx from "clsx";
import { useContext } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Icon } from "components/Icon";
import { TabsMenuContext } from "contexts/TabsMenuContext";
import { useAuth } from "contexts/auth";
import { MenuChildrenType } from "contexts/TabsMenuContext/types";
import { useNavigate, useLocation } from "react-router-dom";

interface NavLinkTypes {
  item: MenuChildrenType;
  isExpand?: boolean;
}

const NavLink = ({ item }: NavLinkTypes) => {
  const tabsMenuContext = useContext(TabsMenuContext);
  //   const router = useRouter();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const hasUserAccessToLink = () => {
    // if (user && !user?.isAdmin && item.accessLabel) {
    //   return user?.accessiblePages?.includes(item.accessLabel);
    // }
    return true;
  };

  // Absolute URL for the menu entry — the SPA is served from the app root, so
  // the router path maps straight onto a browser-navigable URL.
  const getFullPath = () =>
    `${window.location.origin}${
      item.path.startsWith("/") ? item.path : `/${item.path}`
    }`;

  const openInNewTab = () => {
    if (!item.path) return;
    window.open(getFullPath(), "_blank", "noopener,noreferrer");
  };

  const onOpenInNewTabClickHandler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    openInNewTab();
  };
  const onPinIconClick = (e: any, item: MenuChildrenType) => {
    e.preventDefault();
    e.stopPropagation();
    if (item.isPinned) {
      tabsMenuContext.removePinnedMenu(item.name);
    } else {
      tabsMenuContext.addPinnedMenu(item.name);
    }
  };

  return (
    <>
      <ListItem
        disablePadding
        className={clsx(
          "nav-link",
          hasUserAccessToLink() && item.showInMenu ? "block" : "hidden"
        )}
      >
        <ListItemButton
          className={clsx(
            "group w-[90%] flex flex-wrap items-center justify-between rounded-lg hover:bg-gray-40 hover:text-gray-white",
            item.isActive ? "bg-primary-90" : "",
            "pr-4 pl-0 mt-1"
          )}
          onAuxClick={(e) => {
            // Middle-click — the browser convention for "open in new tab".
            if (e.button !== 1) return;
            e.preventDefault();
            e.stopPropagation();
            openInNewTab();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            // Ctrl/Cmd-click opens a browser tab instead of switching the
            // in-app tab, matching how a real link behaves.
            if (e.ctrlKey || e.metaKey) {
              openInNewTab();
              return;
            }

            if (item.isUnique && tabsMenuContext.isTabInActiveTabItems(item)) {
              tabsMenuContext.activateTab(item);
            } else {
              tabsMenuContext.onMenuItemClick(item);
            }

            if (pathname !== item.path) {
              navigate(item.path);
            }
          }}
        >
          <div
            className={clsx(
              "text-inherit whitespace-pre-wrap flex justify-between w-full h-full items-center",
              item.isActive && "!text-gray-white"
            )}
          >
            {item.title}
            {item.hasNotification && (
              <span className="text-red-700 mr-2 font-bold">•</span>
            )}
            <div className={"flex gap-x-1 h-full items-center"}>
              <Tooltip
                title={"باز کردن در تب جدید مرورگر"}
                placement={"top"}
                arrow
              >
                <IconButton
                  className="p-0 hidden group-hover:block"
                  onClick={onOpenInNewTabClickHandler}
                >
                  <Icon
                    className={clsx(
                      "text-lg hover:bg-neutral-45 rounded ml-2 text-gray-80",
                      item.isActive && "!text-gray-white hover:bg-neutral-60"
                    )}
                    icon="MdOpenInNew"
                  />
                </IconButton>
              </Tooltip>

              <Tooltip
                title={item.isPinned ? "حذف سنجاق" : "سنجاق کردن"}
                placement={"top"}
              >
                <IconButton
                  className="p-[1px] hidden group-hover:block"
                  onClick={(e) => {
                    onPinIconClick(e, item);
                  }}
                >
                  <Icon
                    className={clsx(
                      "text-sm hover:bg-neutral-45 rounded ml-2 text-gray-80"
                    )}
                    icon="MdOutlinePushPin"
                  />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </ListItemButton>
      </ListItem>
    </>
  );
};

export default NavLink;
